export default "__VITE_ASSET__31a9f011__"